import { FC } from "react";
import { Button } from "@mui/material";
import { ButtonProps } from "@mui/material/Button";

type IButtonCore = ButtonProps & {
  title?: string | undefined;
};

export const ButtonCore: FC<IButtonCore> = ({
  title,
  onClick,
  ...props
}: IButtonCore) => {
  return (
    <Button
      variant="contained" // comentar
      onClick={onClick} // comentar
      sx={{
        letterSpacing: ".8px",
        ...props.sx,
      }}
      {...props}
    >
      {title}
    </Button>
  );
};
